/* Pawvelle theme scripts */
(function () {
  'use strict';
  var PV = window.Pawvelle || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animate = PV.animations !== false && !reduceMotion;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = PV.moneyFormat || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }
  PV.formatMoney = formatMoney;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = $$('[data-reveal], [data-bars]');
    if (!animate || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      $$('[data-count]').forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        $$('[data-count]', e.target).forEach(countUp);
        if (e.target.hasAttribute('data-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    if (el.__counted) return;
    el.__counted = true;
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var decimals = (String(target).split('.')[1] || '').length;
    var start = null, dur = 1500;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = (0).toFixed(decimals);
    requestAnimationFrame(step);
  }

  /* ---------- Header + announcement ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    $$('[data-announcement]').forEach(function (bar) {
      var slides = $$('.announcement__slide', bar);
      if (slides.length < 2) return;
      var i = 0;
      setInterval(function () {
        var cur = slides[i];
        i = (i + 1) % slides.length;
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        slides[i].classList.add('is-active');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 650);
      }, 4200);
    });
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    var focusable = $('button, a', drawer.querySelector('.drawer__panel'));
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer');
    if (lastFocus) lastFocus.focus();
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) { closeDrawer(closer.closest('.drawer')); return; }
      var cartOpen = e.target.closest('[data-cart-open]');
      if (cartOpen && $('[data-cart-drawer]')) { e.preventDefault(); refreshCart().then(function () { openDrawer($('[data-cart-drawer]')); }); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
    });
  }

  /* ---------- Cart ---------- */
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function iconSvg(path) { return '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">' + path + '</svg>'; }

  function renderCart(cart) {
    var wrap = $('[data-cart-items]');
    var foot = $('[data-cart-foot]');
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; el.setAttribute('data-items', cart.item_count); });
    var countText = $('[data-cart-count-text]');
    if (countText) countText.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="cart-empty"><div class="icon-badge">' + iconSvg('<path d="M5 8h14l-1 13H6L5 8z"/><path d="M9 8V6a3 3 0 016 0v2"/>') + '</div><p>Your cart is empty.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }
    wrap.innerHTML = cart.items.map(function (item, idx) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
      var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<div class="cart-item">' +
        (img ? '<img class="cart-item__img" src="' + img + '" alt="">' : '<span class="cart-item__img"></span>') +
        '<div><a class="cart-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant +
        '<div class="qty"><button type="button" data-line="' + (idx + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">' + iconSvg('<path d="M5 12h14"/>') + '</button><span>' + item.quantity + '</span><button type="button" data-line="' + (idx + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">' + iconSvg('<path d="M12 5v14M5 12h14"/>') + '</button></div></div>' +
        '<div class="cart-item__price">' + formatMoney(item.final_line_price) + was + '</div></div>';
    }).join('');
    if (foot) {
      foot.hidden = false;
      var total = $('[data-cart-total]'); if (total) total.textContent = formatMoney(cart.total_price);
      var discRow = $('[data-cart-discount-row]'), disc = $('[data-cart-discount]');
      if (discRow && disc) { discRow.hidden = !(cart.total_discount > 0); disc.textContent = '-' + formatMoney(cart.total_discount); }
    }
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; }).catch(function () {});
  }
  function initCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-items] [data-line]');
      if (!btn) return;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(btn.getAttribute('data-line')), quantity: Math.max(0, Number(btn.getAttribute('data-qty'))) }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  /* ---------- Product ---------- */
  function initProduct(section) {
    var form = $('[data-product-form]', section) || $('form[action*="/cart/add"]', section);
    if (!form) return;
    var variantInput = $('[data-variant-input]', form);
    var qtyInput = $('[data-qty-input]', form);
    var priceEl = $('[data-price]', section), compareEl = $('[data-compare]', section);
    var saveEl = $('[data-save]', section), saveAmt = $('[data-save-amount]', section);
    var atc = $('[data-atc]', section), sticky = $('[data-sticky-atc]');
    var stickySummary = $('[data-sticky-summary]');
    var bundles = $$('[data-bundle]', section);

    function select(b) {
      bundles.forEach(function (x) { x.classList.toggle('is-selected', x === b); var r = $('input', x); if (r) r.checked = x === b; });
      var price = Number(b.getAttribute('data-price')), compare = Number(b.getAttribute('data-compare'));
      if (variantInput) variantInput.value = b.getAttribute('data-variant');
      if (qtyInput) qtyInput.value = b.getAttribute('data-qty');
      if (priceEl) priceEl.textContent = formatMoney(price);
      var saving = compare > price;
      if (compareEl) { compareEl.hidden = !saving; compareEl.textContent = formatMoney(compare); }
      if (saveEl) { saveEl.hidden = !saving; if (saveAmt) saveAmt.textContent = formatMoney(compare - price); }
      if (stickySummary) stickySummary.textContent = b.getAttribute('data-label') + ' · ' + formatMoney(price);
    }
    if (bundles.length) {
      bundles.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); select(b); }); });
      select($('.bundle.is-selected', section) || bundles[0]);
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch || PV.cartDrawer === false || !$('[data-cart-drawer]')) return;
      e.preventDefault();
      if (atc) { atc.classList.add('is-loading'); atc.disabled = true; }
      var body = { items: [{ id: Number(variantInput ? variantInput.value : 0), quantity: Number(qtyInput ? qtyInput.value : 1) }] };
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer($('[data-cart-drawer]')); })
        .catch(function () { form.submit(); })
        .finally(function () { if (atc) { atc.classList.remove('is-loading'); atc.disabled = false; } });
    });

    var stickyBtn = $('[data-sticky-submit]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
    }

    /* Delivery estimate */
    $$('[data-delivery]', section).forEach(function (el) {
      function addBusinessDays(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var day = x.getDay(); if (day !== 0 && day !== 6) n--; } return x; }
      var now = new Date();
      var min = addBusinessDays(now, Number(el.getAttribute('data-min')) || 7);
      var max = addBusinessDays(now, Number(el.getAttribute('data-max')) || 12);
      var f = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); };
      var target = $('[data-delivery-dates]', el);
      if (target) target.textContent = f(min) + ' – ' + f(max);
    });

    /* Gallery */
    var gallery = $('[data-gallery]', section);
    if (gallery) {
      var track = $('[data-gallery-track]', gallery);
      var thumbs = $$('[data-gallery-thumbs] .gallery__thumb', gallery);
      var go = function (i) { var n = track.children.length; i = (i + n) % n; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); };
      var current = function () { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); };
      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = current();
          thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
          if (thumbs[i]) { var row = thumbs[i].parentNode; row.scrollTo({ left: thumbs[i].offsetLeft - row.clientWidth / 2 + 39, behavior: 'smooth' }); }
        });
      }, { passive: true });
    }
  }

  /* ---------- Sliders ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      var dotsWrap = $('[data-slider-dots]', slider);
      if (!track) return;
      var cardWidth = function () { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth; };
      var perView = function () { return Math.max(1, Math.round(track.clientWidth / cardWidth())); };
      var pages = function () { return Math.max(1, track.children.length - perView() + 1); };
      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pages(); i++) {
          var d = document.createElement('span');
          d.className = 'slider__dot' + (i === 0 ? ' is-active' : '');
          dotsWrap.appendChild(d);
        }
      }
      function update() {
        var i = Math.round(track.scrollLeft / cardWidth());
        $$('.slider__dot', dotsWrap).forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      buildDots();
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', buildDots);
      var prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    });
  }

  /* ---------- Accordions (smooth) ---------- */
  function initAccordions() {
    $$('details.acc').forEach(function (d) {
      var summary = $('summary', d), body = $('.acc__body', d);
      if (!summary || !body) return;
      summary.addEventListener('click', function (e) {
        if (!animate) return;
        e.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () {
            body.style.transition = 'height .35s ease';
            body.style.height = '0px';
          });
          setTimeout(function () { d.open = false; body.style.cssText = ''; }, 360);
        } else {
          d.open = true;
          var h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function () {
            body.style.transition = 'height .4s ease';
            body.style.height = h + 'px';
          });
          setTimeout(function () { body.style.cssText = ''; }, 420);
        }
      });
    });
  }

  /* ---------- Marquee ---------- */
  function initMarquee() {
    $$('[data-marquee]').forEach(function (track) {
      var items = Array.prototype.slice.call(track.children);
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 2.2 && guard < 6) {
        items.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); track.appendChild(c); });
        guard++;
      }
    });
  }

  /* ---------- Reviews: show more ---------- */
  function initReviews() {
    $$('[data-reviews-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.closest('section').querySelector('[data-reviews-list]');
        $$('[data-more]', list).slice(0, 6).forEach(function (r) { r.hidden = false; r.removeAttribute('data-more'); r.classList.add('is-in'); });
        if (!$('[data-more]', list)) btn.parentNode.remove();
      });
    });
  }

  function init() {
    document.documentElement.classList.add('pv-ready');
    initReveal();
    initHeader();
    initDrawers();
    initCart();
    initSliders();
    initAccordions();
    initMarquee();
    initReviews();
    $$('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function () { initReveal(); initSliders(); initAccordions(); initMarquee(); $$('[data-product-section]').forEach(initProduct); });
})();
